export const dict: Record<string, string> = {
  "ui.sessionReview.title": "Session changes",
  "ui.sessionReview.diffStyle.unified": "Unified",
  "ui.sessionReview.diffStyle.split": "Split",
  "ui.sessionReview.expandAll": "Expand all",
  "ui.sessionReview.collapseAll": "Collapse all",
  "ui.sessionReview.change.newFile": "New file",
  "ui.sessionReview.change.removed": "Removed",
  "ui.sessionReview.change.modified": "Modified",
  "ui.sessionReview.summary.added": "Added",
  "ui.sessionReview.summary.removed": "Removed",
  "ui.sessionReview.largeDiff.title": "Diff too large to render",
  "ui.sessionReview.largeDiff.meta":
    "Limit: {{limit}} changed lines. Current: {{current}} changed lines.",
  "ui.sessionReview.largeDiff.renderAnyway": "Render anyway",
  "ui.sessionReview.openFile": "Open file",

  "ui.fileMedia.kind.image": "image",
  "ui.fileMedia.kind.audio": "audio",
  "ui.fileMedia.state.removed": "Removed {{kind}} file.",
  "ui.fileMedia.state.loading": "Loading {{kind}}…",
  "ui.fileMedia.state.error": "Unable to load {{kind}}.",
  "ui.fileMedia.state.unavailable": "{{kind}} preview unavailable.",
  "ui.fileMedia.binary.title": "Binary file",
  "ui.fileMedia.binary.description.path": "{{path}} is binary.",
  "ui.fileMedia.binary.description.default": "Binary content",



  "ui.sessionTurn.retry.retrying": "retrying",
  "ui.sessionTurn.retry.inSeconds": "in {{seconds}}s",
  "ui.sessionTurn.retry.attempt": "attempt #{{attempt}}",
  "ui.sessionTurn.retry.attemptLine": "{{line}} - attempt #{{attempt}}",
  "ui.sessionTurn.retry.geminiHot": "gemini is way too hot right now",
  "ui.sessionTurn.retry.providerOverloaded": "the model provider is overloaded right now",
  "ui.sessionTurn.retry.providerUnavailable": "the model provider is temporarily unavailable",
  "ui.sessionTurn.retry.quotaExhausted": "the provider account has no quota available; waiting for reset",
  "ui.sessionTurn.retry.rateLimited": "the model provider is rate limiting requests",
  "ui.sessionTurn.retry.providerTimeout": "the model provider took too long to respond",
  "ui.sessionTurn.retry.providerConnection": "the connection to the model provider was interrupted",
  "ui.sessionTurn.retry.providerTransient": "the model provider returned a temporary error",

  "ui.sessionTurn.status.gatheringContext": "Exploring",
  "ui.sessionTurn.status.gatheredContext": "Explored",
  "ui.sessionTurn.status.working": "Working",
  "ui.sessionTurn.status.worked": "Worked",
  "ui.sessionTurn.outline.calls.one": "{{count}} call",
  "ui.sessionTurn.outline.calls.other": "{{count}} calls",
  "ui.sessionTurn.outline.loading": "Loading the work…",
  "ui.messagePart.work.collapse": "Collapse work",
  "ui.sessionTurn.status.thinking": "Thinking",
  "ui.sessionTurn.status.waitingResults.one": "Waiting for {{count}} result",
  "ui.sessionTurn.status.waitingResults.other": "Waiting for {{count}} results",

  "ui.messagePart.title.edit": "Edit",
  "ui.messagePart.title.write": "Write",
  "ui.messagePart.fileEdits.ops": "{{count}} operations",
  "ui.messagePart.fileEdits.diffUnavailable": "The recorded diff is unavailable or incomplete.",
  "ui.messagePart.fileEdits.diffLoading": "Loading full diff…",
  "ui.messagePart.fileEdits.diffRetry": "Retry",
  "ui.messagePart.option.typeOwnAnswer": "Type your own answer",
  "ui.messagePart.questions.dismissed": "Questions dismissed",
  "ui.messagePart.compaction": "Session compacted",
  "ui.messagePart.compacting": "Compacting session",
  "ui.messagePart.compactionInterrupted": "Compaction interrupted",
  "ui.messagePart.compaction.collapse": "Collapse compaction summary",
  "ui.messagePart.retry": "{{message}}, retry {{attempt}}",
  "ui.messagePart.context.collapse": "Collapse used tools",
  "ui.messagePart.tools.summary": "{{status}} {{tools}}",

  "ui.list.loading": "Loading",
  "ui.list.empty": "No results",
  "ui.list.clearFilter": "Clear filter",
  "ui.list.emptyWithFilter.prefix": "No results for",
  "ui.list.emptyWithFilter.suffix": "",

  "ui.fileSearch.placeholder": "Find",
  "ui.fileSearch.previousMatch": "Previous match",
  "ui.fileSearch.nextMatch": "Next match",
  "ui.fileSearch.close": "Close search",


  "ui.textField.copyToClipboard": "Copy to clipboard",
  "ui.textField.copyLink": "Copy link",
  "ui.textField.copied": "Copied",

  "ui.imagePreview.alt": "Image preview",
  "ui.scrollView.ariaLabel": "scrollable content",

  "ui.tool.read": "Read",
  "ui.tool.loaded": "Loaded",
  "ui.tool.list": "List",
  "ui.tool.glob": "Glob",
  "ui.tool.grep": "Grep",
  "ui.tool.task": "Task",
  "ui.tool.webfetch": "Webfetch",
  "ui.tool.websearch": "Web Search",
  "ui.tool.codesearch": "Code Search",
  "ui.tool.shell": "Shell",
  "ui.tool.lsp": "LSP",
  "ui.tool.lsp.operation": "language server",
  "ui.tool.patch": "Patch",
  "ui.tool.questions": "Questions",
  "ui.tool.agent": "{{type}} Agent",
  "ui.tool.agent.default": "Agent",
  "ui.tool.skill": "Skill",
  "ui.tool.git.status": "Status",
  "ui.tool.git.diff": "Diff",
  "ui.tool.git.log": "Log",
  "ui.tool.git.show": "Show",
  "ui.tool.git.blame": "Blame",

  // A call's row title: present tense while it runs, past tense once it ends.
  "ui.toolVerb.read.active": "Reading",
  "ui.toolVerb.read.done": "Read",
  "ui.toolVerb.list.active": "Listing",
  "ui.toolVerb.list.done": "Listed",
  "ui.toolVerb.glob.active": "Finding",
  "ui.toolVerb.glob.done": "Found",
  "ui.toolVerb.grep.active": "Searching",
  "ui.toolVerb.grep.done": "Searched",
  "ui.toolVerb.webfetch.active": "Fetching",
  "ui.toolVerb.webfetch.done": "Fetched",
  "ui.toolVerb.websearch.active": "Searching the web",
  "ui.toolVerb.websearch.done": "Searched the web",
  "ui.toolVerb.codesearch.active": "Searching code",
  "ui.toolVerb.codesearch.done": "Searched code",
  "ui.toolVerb.lsp.active": "Checking",
  "ui.toolVerb.lsp.done": "Checked",
  "ui.toolVerb.edit.active": "Editing",
  "ui.toolVerb.edit.done": "Edited",
  "ui.toolVerb.write.active": "Writing",
  "ui.toolVerb.write.done": "Wrote",
  "ui.toolVerb.apply_patch.active": "Patching",
  "ui.toolVerb.apply_patch.done": "Patched",
  "ui.toolVerb.capability_load.active": "Loading",
  "ui.toolVerb.capability_load.done": "Loaded",
  "ui.toolVerb.capability_search.active": "Searching capabilities",
  "ui.toolVerb.capability_search.done": "Searched capabilities",

  "ui.basicTool.called": "Called `{{tool}}`",
  "ui.basicTool.calling": "Calling `{{tool}}`",
  "ui.basicTool.awaitingApproval": "Waiting for approval",
  "ui.basicTool.collapse": "Collapse",
  "ui.toolErrorCard.failed": "Failed",
  "ui.toolErrorCard.copyError": "Copy error",

  "ui.common.file.one": "file",
  "ui.common.file.other": "files",
  "ui.common.question.one": "question",
  "ui.common.question.other": "questions",

  "ui.common.back": "Back",
  "ui.common.dismiss": "Dismiss",
  "ui.common.close": "Close",
  "ui.common.next": "Next",
  "ui.common.submit": "Submit",
  "ui.common.copyFailed": "Could not copy",
  "ui.common.copyFailedDescription": "Select the text and copy it manually.",

  "ui.permission.deny": "Deny",
  "ui.permission.allowAlways": "Allow in this chat and its subagents",
  "ui.permission.allowAllDesktopSteps": "Allow all desktop steps in this chat and its subagents",
  "ui.permission.allowOnSite": "Allow on {{site}} in this chat and its subagents",
  "ui.permission.allowAllDesktopStepsInParent": "Allow all desktop steps in the parent chat and its subagents",
  "ui.permission.allowOnSiteInParent": "Allow on {{site}} in the parent chat and its subagents",
  "ui.permission.allowAllCommands": "Allow every command in this chat and its subagents (not recommended)",
  "ui.permission.allowOnce": "Allow once",

  "ui.message.copy": "Copy",
  "ui.message.copyMessage": "Copy message",
  "ui.message.forkMessage": "Fork to new session",
  "ui.message.restartMessage": "Restart message",
  "ui.message.copyResponse": "Copy response",
  "ui.message.copied": "Copied",
  "ui.message.duration.seconds": "{{count}}s",
  "ui.message.duration.minutesSeconds": "{{minutes}}m {{seconds}}s",
  "ui.message.interrupted": "Interrupted",
  "ui.message.attachment.alt": "attachment",

  "ui.patch.action.deleted": "Deleted",
  "ui.patch.action.created": "Created",
  "ui.patch.action.moved": "Moved",

  "ui.question.subtitle.answered": "{{count}} answered",
  "ui.question.answer.none": "(no answer)",
  "ui.question.multiHint": "Select all answers that apply",
  "ui.question.singleHint": "Select one answer",
  "ui.question.custom.placeholder": "Type your answer…",
};
